import axios from "axios";
import { logout } from "./redux/Slices/Auth";
import { store } from "./redux/store";
import { toast } from "react-toastify";
import {
  resetIsServerError,
  setIsServerError,
} from "./redux/Slices/SystemSlice";
import { API_URL } from "./config";

const axiosConfig = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

const fireLogout = () => {
  if (store.getState().auth.logged) store.dispatch(logout());
};

axiosConfig.interceptors.request.use(function (config) {
  let token = localStorage.getItem("token");
  config.headers.Authorization = `Bearer ${token}`;
  return config;
});
axiosConfig.interceptors.response.use(
  (res) => {
    return res;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      toast.error(
        error.response?.data?.message || "Authorization error: login again"
      );
      fireLogout();
    } else if (error.response && error.response.status === 500) {
      if (
        error.response.data?.message ===
        "Something went wrong, try again later! jwt malformed"
      ) {
        fireLogout();
      } else store.dispatch(setIsServerError());
    } else {
      store.dispatch(resetIsServerError());
    }
    return Promise.reject(error);
  }
);

export default axiosConfig;
